
import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import DataTableComponent from '@/components/DataTableComponent.vue';
import _ from 'lodash';

@Component({
  components: {
    DataTableComponent,
  },
})
export default class CrudArrayComponent extends Vue {
  @Prop(Array) readonly propAddItems;

  @Prop({ default: true }) readonly propSearch;
  @Prop({ default: true }) readonly flat;

  @Prop({ default: true }) readonly allowAdd;

  @Prop({ default: true }) readonly allowEdit;

  @Prop({ default: true }) readonly allowDelete;

  @Prop(String) readonly propWidth;

  @Prop(String) readonly propHeight;
  // @ts-ignore
  @Prop() propHeaders;

  @Prop() propItems;

  @Prop(String) readonly propTitle;

  public itemToAdd = null;

  public editedIndex = null;

  public editedItem = {};

  public editDialog = false;

  public deleteDialog = false;

  public addDialog = false;

  public items = [];

  public headers = [];

  public errors = '';

  @Watch('itemToAdd', { deep: true })
  onChangeItemToAdd() {
    if (!this.items.includes(this.itemToAdd!)) {
      this.errors = '';
    } else {
      this.errors = 'Já existe!';
    }
  }

  @Watch('propHeaders')
  async onHeadersUpdate(val) {
    this.headers = val;
  }

  @Watch('propItems', { deep: true, immediate: true })
  async onArrayUpdate(val) {
    this.items = val;
  }

  @Emit('onUpdateArray')
  onUpdateArray() {
    return this.items;
  }

  @Watch('items')
  onchangeItems() {
    this.onUpdateArray();
  }

  get fields() {
    return this.propHeaders.filter((value) => {
      return !value.hide_field;
    });
  }

  public async cancelEditItem() {
    this.editedIndex = null;
    this.editedItem = {};
  }

  public async saveItem() {
    if (this.editedIndex !== null) {
      //@ts-ignore
      this.$set(this.items, this.editedIndex, this.editedItem);
    } else {
      //@ts-ignore
      this.items.push(this.editedItem);
    }
    // @ts-ignore
    this.editedItem = {};
  }

  public async editItem(item) {
    //@ts-ignore
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
  }

  public async deleteItem(item) {
    //@ts-ignore
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.deleteDialog = true;
  }

  public async addItem(item) {
    //@ts-ignore
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.addDialog = true;
  }

  public filterCheckoutEmailAdd(item) {
    const conditions = ['@knnidiomas', '@knnbrasil', '@phenomidiomas', '@phenombrasil'];
    item = item.filter((f) => conditions.some((el) => f.email.includes(el)));
    return item;
  }

  deleteItemConfirm() {
    //@ts-ignore
    this.items.splice(this.editedIndex, 1);
    this.closeDialog();
  }

  addItemConfirm(item) {
    //@ts-ignore
    this.items.unshift(item);
    this.itemToAdd = null;
    this.closeDialog();
  }

  public async close() {
    //@ts-ignore
    this.dialog = false;
    this.$nextTick(() => {
      //@ts-ignore
      this.editedItem = Object.assign({}, this.defaultItem);
      //@ts-ignore
      this.editedIndex = -1;
    });
  }

  public async closeDialog() {
    this.deleteDialog = false;
    this.addDialog = false;
    this.$nextTick(() => {
      //@ts-ignore
      this.editedItem = Object.assign({}, this.defaultItem);
      //@ts-ignore
      this.editedIndex = -1;
    });
  }

  public async save() {
    //@ts-ignore
    if (this.editedIndex > -1) {
      //@ts-ignore
      Object.assign(this.items[this.editedIndex], this.editedItem);
    } else {
      //@ts-ignore
      this.items.push(this.editedItem);
    }
    this.close();
  }

  renderTriggered() {
    this.items = this.propItems;
  }

  mounted() {
    if (!this.propHeaders) {
      this.headers.push({
        //@ts-ignore
        text: 'Ações',
        //@ts-ignore
        value: 'actions',
      });
    }
  }
}
